import { call, put, select, delay, takeLatest } from 'redux-saga/effects';
import {
  setUserInputUpdateFailedAction,
  setUserInputUpdateSuccessAction,
  USER_INPUT_UPDATE_START,
  UserInputUpdateStartAction,
} from '../actions/UserInputAction';
import ApiUtil from 'src/utils/ApiUtil';
import ApplicationState from 'src/model/ApplicationState';
import GetUserInputResponse from 'src/model/UserInput';
import RequestStatus from 'src/model/RequestStatus';
import { USER_INPUT_UPDATE_DELAY_MS } from 'src/config/Config';

export const getUserInput = (state: ApplicationState) => state.userInputRes;
export function* setUserInput(action: UserInputUpdateStartAction) {
  try {
    yield put(setUserInputUpdateSuccessAction(action.UserInput));
    yield delay(USER_INPUT_UPDATE_DELAY_MS);
    const userInputResponse: GetUserInputResponse = yield select(getUserInput);
    const userInputData =
      (userInputResponse &&
        userInputResponse.requestStatus === RequestStatus.SUCCESS &&
        userInputResponse.data) ||
      {};
    yield call(ApiUtil.postApiWithTimeout, 'setuserinput', userInputData);
  } catch (error) {
    console.error('Call API setuserinput error' + error);
    yield put(setUserInputUpdateFailedAction());
  }
}

export default function* userInputUpdate() {
  yield takeLatest(USER_INPUT_UPDATE_START, setUserInput);
}
